import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import type { Nullable, Protocol } from "@msuite/utils/types";
import { client } from "@/hono";

export function useProtocol(protocolId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["protocol", protocolId ?? "--"],
		queryFn: async () => {
			if (!protocolId) throw new Error("No protocol ID");
			const response = await client.protocols[":protocolId"].$get({
				param: { protocolId },
			});
			const data = await responseHandler(response);
			return {
				protocol: data.protocol as Nullable<Protocol>,
				protocolForm: data.protocolForm as ProtocolFormSchema,
			};
		},
		enabled: !!protocolId,
	});

	/** Return */
	return {
		...query,
		protocol: query.data?.protocol,
		protocolForm: query.data?.protocolForm,
	};
}
